import { mutationNames } from '@/store/storeKeysettings'

const state = {
    Instagram: {
      'Id': 0,
      'PageTitle': '',
      'RowCreated': null,
      'RowUpdated': null,
      'SubscriptionModuleActivation_Id': 0,
      'InstagramId': '',
      'Module_Id': ''
    }
}

const mutations = {
    [mutationNames.SET_INSTAGRAM](state, instagram) {
      state.Instagram = instagram
    },
    [mutationNames.UPDATE_INSTAGRAM](state, instagram) {
      state.Instagram = instagram
    }
}

const actions = {
    initInstagram: ({commit}) => {
      commit(mutationNames.SET_INSTAGRAM)
    }
}

const getters = {
    Instagram: state => {
      return state.Instagram
    }
}

export default {
    state,
    mutations,
    actions,
    getters
}



// WEBPACK FOOTER //
// ./src/store/modules/instagram.js